import { Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import { InstantFeedbackDTOList } from '../../dtos/instant-feedback.dto';
import { InstantFeedbackDTOFromAPIResponse } from '../../helpers/translators/instant-feedback.translators';
import { InstantFeedbackResponseList } from '../../types/responses/instant-feedback.responses';

@Injectable({
  providedIn: 'root',
})
export class InstantFeedbackService {
  constructor(private apiCoreService: APICoreService) {}

  getSmartFeedback(
    evidenceId: number
  ): Observable<{ ai_instant_feedback_id: number } | { error: string }> {
    return this.apiCoreService
      .getRequest(`ai/evidence-feedback?evidence_id=${evidenceId}`)
      .pipe(
        catchError((err) => {
          throw err;
        })
      );
  }

  getAllSmartFeedbackForUser(page = 1): Observable<InstantFeedbackDTOList> {
    return this.apiCoreService
      .getRequest(
        `ai/smart-feedback?exclude_evidence_smart_feedback=true&page=${page}`
      )
      .pipe(
        map(
          (response: InstantFeedbackResponseList): InstantFeedbackDTOList => ({
            ...response,
            items: response.items.map(InstantFeedbackDTOFromAPIResponse),
          })
        ),
        catchError((err) => {
          throw err;
        })
      );
  }

  getCardFeedback(
    compId: number,
    artifact: File | null,
    narrative: string | null
  ): Observable<{ ai_instant_feedback_id: number } | { error: string }> {
    const formData = new FormData();
    if (artifact) {
      formData.append('file', artifact);
    }
    if (narrative) {
      formData.append('narrative', narrative);
    }
    formData.append('competency_id', compId.toString());
    return this.apiCoreService
      .postFormRequest('ai/smart-feedback', formData)
      .pipe(
        catchError((err) => {
          throw err;
        })
      );
  }

  submitUserFeedback(feedbackId: number, thumbDirection: string) {
    return this.apiCoreService.postRequest(
      `ai/smart-feedback/${feedbackId}/user-feedback`,
      {
        user_feedback: thumbDirection,
      }
    );
  }
}
